<div class="row align-items-center py-2"
  [style.background-color]="isHovered ? '#f0fff4' : ''"
  (mouseenter)="isHovered = true"
  (mouseleave)="isHovered = false">

  <div class="col-8 fw-bold">{{label}}</div>

  <div class="col-3 d-flex justify-content-end gap-2 border-bottom border-dotted align-self-stretch ">

    <span *ngIf="keyDate" class="">{{ keyDate | date: 'dd/MM/yyyy' }}</span>

    <span *ngIf="keyDate && enteredByUser" class="text-muted small">
      ({{enteredByUser.firstName.charAt(0)}}{{enteredByUser.lastName.charAt(0)}})
    </span>

  </div>

  <div class="col">
    <fa-icon *ngIf="canAdd && !keyDate && !readOnly" [icon]="faPlus" class="text-success" style="cursor:pointer" (click)="addDate()"></fa-icon>
    <fa-icon *ngIf="canEdit && keyDate && !readOnly" [icon]="faMinusCircle" class="text-danger" style="cursor:pointer" (click)="deleteDate()"></fa-icon>
  </div>

</div>